var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.852 14.497c0-.92.151-1.803.42-2.631l-4.711-3.65a14.336 14.336 0 00-1.436 6.281c0 2.258.517 4.387 1.434 6.277l4.709-3.656a8.497 8.497 0 01-.416-2.62",
    fill: "#fbbc05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 6.12c1.973 0 3.755.71 5.155 1.87l4.072-4.125C20.871 1.674 17.69.32 14.125.32 8.593.32 3.838 3.53 1.561 8.217l4.711 3.65c1.086-3.343 4.18-5.747 7.853-5.747",
    fill: "#ea4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 22.88c-3.672 0-6.767-2.404-7.853-5.746l-4.711 3.648c2.277 4.69 7.032 7.898 12.564 7.898 3.415 0 6.675-1.23 9.122-3.533l-4.473-3.507c-1.261.806-2.85 1.24-4.649 1.24",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.489 14.498c0-.838-.128-1.74-.318-2.578H14.125v5.478h7.51c-.376 1.868-1.398 3.303-2.86 4.238l4.472 3.506c2.57-2.419 4.242-6.023 4.242-10.644",
    fill: "#4285f4"
  })));
}

export default SvgGoogle;